export const RECEIVE_USER = 'RECEIVE_USER'
export const RECEIVE_FAVORITE = 'RECEIVE_FAVORITE'
export const REMOVE_FAVORITE = 'REMOVE_FAVORITE'
export const RECEIVE_USER_LOADING_STATE = 'RECEIVE_USER_LOADING_STATE'
export const RECEIVE_AUTH_TOKEN = 'RECEIVE_AUTH_TOKEN'
export const RECEIVE_PURCHASE = 'RECEIVE_PURCHASE'
export const CLEAR_USER = 'CLEAR_USER'
